import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class RecordGroupService {
  constructor(private http: HttpClientService) {}

  public loadInfo(content): Observable<any> {
    return this.http
      .post("/api/record_group/load_credits", { content })
      .pipe(tap((_) => console.log("RecordGroupService.loadInfo: Ok.")));
  }
}
